import { FC } from 'react';
import NavCommon from '../../Teaser/NavCommon';
import { useMembersStore } from '../../../MembersProvider';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/getLocal';
import { NA_SITES } from '@/constants/membersday';

interface IProps {
    type?: string;
}

const Banner: FC<IProps> = ({}) => {
    const { t } = useLang('membersday.return');
    const { locale } = getLocal();
    const { secKillProduct } = useMembersStore();

    let nav = [
        {
            title: t('nav_title_1'),
            href: 'nav_title_1',
        },
        {
            title: t('nav_title_2'),
            href: 'nav_title_2',
        },
        {
            title: t('nav_title_4'), // uk 这个返场这个不需要
            href: 'nav_title_4',
        },
        {
            title: t('nav_title_3'),
            href: 'nav_title_3',
        },
        {
            title: t('nav_title_5'),
            href: 'nav_title_5',
        },
        {
            title: t('nav_title_6'),
            href: 'teaser-JoinUs',
        },
        {
            title: t('nav_title_7'),
            href: 'teaser-ReferralNext',
        },
    ];

    if (locale === 'uk') {
        nav.splice(2, 1);
    }

    if (NA_SITES.includes(locale)) {
        nav = [
            {
                title: t('nav_title_1'),
                href: 'activity-FlashSale',
            },
            {
                title: t('nav_title_6'),
                href: 'activity-BestSellers',
            },
            {
                title: t('nav_title_3'),
                href: 'activity-BestSellers2',
            },
            {
                title: t('nav_title_4'),
                href: 'activity-Accessories', // ca返场没有这个
            },
            {
                title: t('nav_title_2'),
                href: 'activity-HotBundles',
            },
            {
                title: t('nav_title_5'),
                href: 'teaser-JoinUs',
            },
        ];
        if (locale === 'ca') nav.splice(3, 1);
    }

    if (locale === 'kr') {
        nav = [
            {
                title: t('nav_title_1'),
                href: 'teaser-CelebratingUs',
            },
            // {
            //     title: t('nav_title_2'),
            //     href: 'nav_title_2',
            // },
            {
                title: t('nav_title_3'),
                href: 'nav_title_3',
            },
            {
                title: t('nav_title_4'),
                href: 'teaser-ReferralNext',
            },
        ];
    }

    if (locale === 'jp') {
        nav = [
            {
                title: t('nav_title_1'),
                href: 'activity-FlashSale',
            },
            {
                title: t('nav_title_2'),
                href: 'activity-BestSellers',
            },
            {
                title: t('nav_title_3'),
                href: 'activity-HotBundles',
            },
            {
                title: t('nav_title_4'),
                href: 'activity-HotBundles1',
            },
            {
                title: t('nav_title_5'),
                href: 'teaser-JoinUs',
            },
        ];
    }

    // 如果 秒杀模块返回产品列表为空 则去掉秒杀导航
    const flashSaleIndex = nav.findIndex((item) => item.href === 'activity-FlashSale');
    if (flashSaleIndex > -1 && secKillProduct && secKillProduct.length === 0) nav.splice(flashSaleIndex, 1);

    return (
        <>
            <NavCommon list={nav} />
        </>
    );
};

export default Banner;
